import * as React from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import ReactTooltip from 'react-tooltip';
import NumberFormat from 'react-number-format';
import { connect } from 'react-redux';
import { navigateTo } from '../../../../actions/navigationActions';
import { setIsOnQuoteScreen, switchToBuilding, updateHomeContentOrBuildingToQuote, setQuoteData } from '../../../../actions/salesActions';
import { getAsLocalCurrency } from '../../../../actions/sspActions';
import { BANKING_DETAILS } from '../../../../routes/routes';
import KPSelectableListItem from '../../../BaseTemplate/SSPCustomComponentLibrary/KPSelectableList/KPSelectableListItem';
import { showModalAddBuildingCover } from '../../../../actions/salesModalActions';
import AcceptQuote from '../../AcceptQuote/AcceptQuote';
import './HomeContentQuotation.css';
import { BUILDING_COMPREHENSIVE_PRODUCT_GUID, HOME_CONTENT_COMPREHENSIVE_PRODUCT_GUID, HOME_CONTENT_FIREFURY_PRODUCT_GUID } from '../../../../constants/products';
import { postToController } from '../../../../actions/apiActions';

class HomeContentQuotation extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            coverType: HOME_CONTENT_COMPREHENSIVE_PRODUCT_GUID,
            replacementValue: this.props.sales.buildingReplacementValue ?? 0,
            canUpdate: false,
            minValue: 0,
            maxValue: 5000000,
            showMinMaxError: false,
        };

        this.handleAcceptQuote = this.handleAcceptQuote.bind(this);
        this.handleReplacementValueChange = this.handleReplacementValueChange.bind(this);
        this.handleUpdateReplacementValue = this.handleUpdateReplacementValue.bind(this);
        this.handleCoverTypeChange = this.handleCoverTypeChange.bind(this);
        this.handleGetMinMaxValues = this.handleGetMinMaxValues.bind(this);
    }

    async handleAcceptQuote(e: any) {
        this.props.dispatchAction(setIsOnQuoteScreen(false, "", ""));
        if (!this.props.sales.buildingContinueQuote) {
            this.props.dispatchAction(showModalAddBuildingCover());
        } else {
            this.props.dispatchAction(navigateTo(BANKING_DETAILS));
        }
    }

    async componentDidMount() {
        this.handleGetMinMaxValues(HOME_CONTENT_COMPREHENSIVE_PRODUCT_GUID);
    }

    async handleGetMinMaxValues(productId: string) {
        postToController(this.props.dispatch, 'GetBuildingContentMixMaxValue', JSON.stringify({ ProductId: productId, CountryId: this.props.profile.countryId })).then(async (response) => {
            this.setState({ minValue: response.minimumValue, maxValue: response.maximumValue });
        });
    }

    handleCoverTypeChange(id: string, selected: boolean) {
        if (id !== this.state.coverType) {
            this.setState({ coverType: id });
            this.props.dispatchAction(updateHomeContentOrBuildingToQuote(id, this.state.replacementValue.replaceAll(",", "").replace(this.props.profile.currencySymbol, "")));
            this.handleGetMinMaxValues(id);
        }
    }

    handleReplacementValueChange(e: any) {
        let canUpdateValue = true
        if (Number(e.target.value.replaceAll(",", "").replaceAll(this.props.profile.currencySymbol, "")) < this.state.minValue || Number(e.target.value.replaceAll(",", "").replaceAll(this.props.profile.currencySymbol, "")) > this.state.maxValue) {
            canUpdateValue = false
        }
        this.setState({ replacementValue: e.target.value, canUpdate: canUpdateValue, showMinMaxError: !canUpdateValue });
    }

    handleUpdateReplacementValue() {
        this.props.dispatchAction(updateHomeContentOrBuildingToQuote(this.state.coverType, Number(this.state.replacementValue.replaceAll(",", "").replaceAll(this.props.profile.currencySymbol, ""))));
        this.setState({ canUpdate: false });
        let replacementValue = this.state.replacementValue.replaceAll(",", "");
        this.props.dispatchAction(setQuoteData({ buildingReplacementValue: replacementValue }));
        // Todo: Update the Quote...
    }

    public render() {
        let premium = this.props.dispatchAction(getAsLocalCurrency(this.props.sales.carPremium));
        let premiumNoSymbol = premium.replace(this.props.profile.currencySymbol, "").trim();
        let excess = this.props.dispatchAction(getAsLocalCurrency(this.props.sales.selectedExcess));

        return (
            <div id="HomeContentSummary">
                <div className={this.props.auth.loggedIn ? "pt-lg-5 p-lg-0 logged-in" : "pt-lg-5 p-lg-0 logged-out"}>
                    <div className="container pt-3 pt-lg-0 mb-4">

                        <div className="row justify-content-center QuoteDetails noma">
                            <div className="col-lg-6 mr-lg-4 cover-detail">
                                <div>
                                    <h3 className="Comprehensive-car mb-1">Home contents insurance</h3>
                                    <div className="Comprehensive-details">{this.props.sales.address}</div>
                                </div>
                            </div>
                            <div className="border-lg-right border-sm-bottom"></div>
                            <div className="col-md-6 col-lg-4 p-0 pt-3 pt-lg-0 mx-auto cover-premium">
                                <p className="Comprehensive-monthly-premium mb-1 text-center">This month’s premium</p>
                                <p className="Comprehensive-total">{premium}</p>
                                <div className="text-center">
                                    <button className="btn btn-solid-green btn-responsive btn-accept-quote-top" id="acceptQuoteTop" onClick={this.handleAcceptQuote}>{this.props.sales.isNewItem ? "Add to quote" : "Update quote"}</button>
                                </div>
                            </div>
                        </div>

                        <div className="justify-content-center">
                            <div className="mt-3">
                                <Tabs id="covertype-tabs" defaultActiveKey="home">
                                    <Tab eventKey="home" title="Overview" className="mb-4">
                                        <div className="summary-instructions">
                                            Insure your home contents for either of these options:
                                        </div>

                                        <div className="row noma mt-3">
                                            <div className="col-md-6 pr-0">
                                                <div className={"row cover-type-selector cover-type-selector-comprehensive" + (this.state.coverType === HOME_CONTENT_COMPREHENSIVE_PRODUCT_GUID ? " selected" : "")}>
                                                    <div className="col-11">
                                                        <KPSelectableListItem
                                                            id={HOME_CONTENT_COMPREHENSIVE_PRODUCT_GUID}
                                                            label="Comprehensive cover"
                                                            value="ComprehensiveCover"
                                                            selected={(this.state.coverType === HOME_CONTENT_COMPREHENSIVE_PRODUCT_GUID)}
                                                            className="radioGroup"
                                                            selectOnLeft={true}
                                                            handleSelect={this.handleCoverTypeChange}
                                                        />
                                                    </div>
                                                    <div className="col-1 nopa">
                                                        <img className="get-home-content-cover-image" src="./Images/OnlineQuotation/BuildingAndHomeContent/building-content-landing-umbrella.svg" alt="Umbrella" title="Umbrella" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 pl-0">
                                                <div className={"row cover-type-selector cover-type-selector-firefury" + (this.state.coverType === HOME_CONTENT_FIREFURY_PRODUCT_GUID ? " selected" : "")}>
                                                    <div className="col-11">
                                                        <KPSelectableListItem
                                                            id={HOME_CONTENT_FIREFURY_PRODUCT_GUID}
                                                            label="Fire and fury cover"
                                                            value="FireFuryCover"
                                                            selected={(this.state.coverType === HOME_CONTENT_FIREFURY_PRODUCT_GUID)}
                                                            className="radioGroup"
                                                            selectOnLeft={true}
                                                            handleSelect={this.handleCoverTypeChange}
                                                        />
                                                    </div>
                                                    <div className="col-1 nopa">
                                                        <img className="get-home-content-cover-image" src="./Images/OnlineQuotation/BuildingAndHomeContent/building-content-landing-house-fire.svg" alt="Fire" title="Fire and Fury" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {(this.state.coverType === HOME_CONTENT_COMPREHENSIVE_PRODUCT_GUID) &&
                                            <div id="pnlHomeContent-Comprehensive" className="notification-panel mt-4">
                                                With <b>comprehensive home contents insurance</b> you’re covered for the loss of, or damage to, items in your home, which belong to you or to any members of your household who live with you, but not including tenants.
                                            </div>
                                        }
                                        {(this.state.coverType === HOME_CONTENT_FIREFURY_PRODUCT_GUID) &&
                                            <div id="pnlHomeContent-FireFury" className="notification-panel mt-4">
                                                With <b>fire and fury home contents insurance</b>, you’re covered for the loss of, or damage to, items in your home, which belong to you and the people who live with you, except if this loss or damage is the result of theft or attempted theft. You're also covered for fire, but not if the fire was started by burglars.
                                            </div>
                                        }

                                        <div className="detail-panel mt-4">
                                            <div className="row">
                                                <div className="col-md-9">
                                                    <div className="label medium text-left">Excess amount
                                                        <img src="./images/icons-line-style-info-32-px.svg" alt="" title="" className="raftooltip ml-10px" data-for="homeContentExcessTooltip" data-tip="" />
                                                        <ReactTooltip id="homeContentExcessTooltip" className="tooltip-gray" place="right" effect="solid" backgroundColor="#3a1826" delayShow={1000}>An excess is payable by you, to your insurer, in the event of a claim</ReactTooltip>
                                                    </div>
                                                    <div className="col-md-3 d-block d-md-none nopa">
                                                        <div className="lblExcess align-center mobile-mt-20px">
                                                            {excess}
                                                        </div>
                                                    </div>
                                                    <div className="mt-3">
                                                        <b>Please note:</b> If something happens for which you need to claim, you’ll be expected to pay the basic excess amount as noted on your policy schedule. You may also be expected to pay any of the additional excess amounts (refer to your policy schedule).
                                                    </div>
                                                </div>
                                                <div className="col-md-3 d-none d-md-block">
                                                    <div className="lblExcess align-center mobile-mt-20px">
                                                        {excess}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="detail-panel-devider"></div>

                                            <div>
                                                <div className="label large text-left">Replacement value</div>
                                                <div className="mt-3">
                                                    Tap on the text box to change your replacement value.
                                                </div>

                                                <div className="row mt-4">
                                                    <div className="col-md-9">
                                                        <NumberFormat
                                                            id="txtReplacementValueInputId"
                                                            name="replacementValueInputId"
                                                            placeholder={this.props.profile.currencySymbol}
                                                            thousandSeparator={true}
                                                            thousandsGroupStyle="thousand"
                                                            prefix={this.props.profile.currencySymbol}
                                                            value={this.state.replacementValue ?? ""}
                                                            required={true}
                                                            className="ssp-inputtextarea-input-element ssp-input-editable-pen"
                                                            onChange={this.handleReplacementValueChange}
                                                        />
                                                        {(!this.state.canUpdate && (this.state.showMinMaxError)) &&
                                                            <p className="replacement-value-help-block mt-10px ml-20px mobile-ml-0px text-lg-left text-center mb-20px">The value needs to be between {this.state.minValue} and {this.state.maxValue}</p>
                                                        }
                                                    </div>
                                                    <div className="col-md-3">
                                                        <button id="btnReplacementValue" className="btn btn-solid-red btn-responsive mobile-mt-20px" onClick={this.handleUpdateReplacementValue} disabled={!this.state.canUpdate} >Update value</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Tab>

                                    <Tab eventKey="covered" title="Covered" className="mb-4">
                                        <div className="covered-panel mt-3">
                                            <div className="covered-panel-title">
                                                What's covered by the king
                                            </div>
                                            <div className="mt-2">
                                                You're covered for the following:
                                            </div>
                                        </div>
                                        <div className="row covered-panel-detail-list mt-3 mb-3">
                                            <div className="col-md-6">
                                                <div className="covered-panel-detail-item large">
                                                    <div className="row">
                                                        <div className="col-2 nopa align-center">
                                                            <div className="bg-covered_image bg-loss-or-damage"></div>
                                                        </div>
                                                        <div className="col-10">
                                                            <div className="label">
                                                                Loss or damage
                                                            </div>
                                                            <>Damage caused by theft, fire, explosion, acts of nature, malicious damage, animals, cars, aircraft, falling trees, and power surges and dips (excluding electricity grid failure or interruption).</>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="covered-panel-detail-item large">
                                                    <div className="row">
                                                        <div className="col-2 nopa align-center">
                                                            <div className="bg-covered_image bg-subsidence"></div>
                                                        </div>
                                                        <div className="col-10">
                                                            <div className="label">
                                                                Subsidence
                                                            </div>
                                                            <>You’re covered for loss of, or damage caused to the contents in your property, by the downward movement of the land that supports it, due to natural shifts or human activity.</>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="covered-panel-detail-item large">
                                                    <div className="row">
                                                        <div className="col-2 nopa align-center">
                                                            <div className="bg-covered_image bg-water-damage"></div>
                                                        </div>
                                                        <div className="col-10">
                                                            <div className="label">
                                                                Loss or damage due to water
                                                            </div>
                                                            <> Leaking, bursting or overflowing of water heating systems, water supply tanks, cisterns and pressurised water pipes.</>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="covered-panel-detail-item large">
                                                    <div className="row">
                                                        <div className="col-2 nopa align-center">
                                                            <div className="bg-covered_image bg-acidental-damage"></div>
                                                        </div>
                                                        <div className="col-10">
                                                            <div className="label">
                                                                Acidental damage
                                                            </div>
                                                            <>You’re covered for accidental damage of TVs and mirrors or glass that form part of any furniture.</>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="covered-panel-detail-item large">
                                                    <div className="row">
                                                        <div className="col-2 nopa align-center">
                                                            <div className="bg-covered_image bg-fire-brigade"></div>
                                                        </div>
                                                        <div className="col-10">
                                                            <div className="label">
                                                                Fire brigade charges
                                                            </div>
                                                            <>You’re covered for charges made by the fire brigade or any public authority following an incident for which you may claim.</>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="covered-panel-detail-item large">
                                                    <div className="row">
                                                        <div className="col-2 nopa align-center">
                                                            <div className="bg-covered_image bg-temporaty-accomodation"></div>
                                                        </div>
                                                        <div className="col-10">
                                                            <div className="label">
                                                                Temporary accommodation
                                                            </div>
                                                            <>You’re covered for loss of, or damage caused to the contents in your property, by the downward movement of the land that supports it, due to natural shifts or human activity.</>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="covered-panel-detail-item large">
                                                    <div className="row">
                                                        <div className="col-2 nopa align-center">
                                                            <div className="bg-covered_image bg-transportation"></div>
                                                        </div>
                                                        <div className="col-10">
                                                            <div className="label">
                                                                Transportation of contents
                                                            </div>
                                                            You’re covered for damage to, or loss of, your belongings if they’re being transported by a registered removal company’s truck, that’s involved in an accident.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Tab>

                                    <Tab eventKey="notcovered" title="Not covered" className="mb-4">
                                        <div className="covered-panel mt-3">
                                            <div className="covered-panel-title">
                                                What's not covered
                                            </div>
                                            <div className="mt-2">
                                                You're not covered for:
                                            </div>
                                        </div>

                                        <div className="row covered-panel-detail-list mt-3 mb-3">
                                            <div className="col-md-6">
                                                <div className="covered-panel-detail-item">
                                                    <div className="label noma">
                                                        Communal living
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="covered-panel-detail-item">
                                                    <div className="label noma">
                                                        Scorching
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="covered-panel-detail-item">
                                                    <div className="label noma">
                                                        Money
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="covered-panel-detail-item">
                                                    <div className="label noma">
                                                        Counterfeit goods
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="covered-panel-detail-item">
                                                    <div className="label noma">
                                                        Cars
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="covered-panel-detail-item">
                                                    <div className="label noma">
                                                        Matching materials
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="covered-panel-detail-item">
                                                    <div className="label noma">
                                                        Vacant, abandoned or illegally occupied properties
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="covered-panel-detail-item">
                                                    <div className="label noma">
                                                        Business or professional use
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="covered-panel-detail-item">
                                                    <div className="label noma">
                                                        Thatch roof
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="covered-panel-detail-item">
                                                    <div className="label noma">
                                                        Security measures that don’t work
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Tab>
                                </Tabs>
                            </div>
                        </div>

                        <div className="text-center mt-3">
                            Overview only. Please refer to our <a href="/Content/documents/King-price-insurance-policy.pdf" target="_blank" className="red-link">KPPD</a> and your policy schedule for more info.
                        </div>

                        <div className="row mt-4 pt-4 d-none d-md-block">
                            <div className="col-12 text-center">
                                <button className="btn btn-solid-green" id="AddToQuote" onClick={this.handleAcceptQuote}>
                                    <span className="Add-to-quote">{this.props.sales.isNewItem ? "Add to quote" : "Update quote"}</span>
                                    <br />
                                    <span className="QuoteTotal">{premium} pm</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <AcceptQuote premuim={premiumNoSymbol} />
            </div >
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        sales: state.sales,
        auth: state.firebase.auth,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeContentQuotation);
